module.exports = __webpack_public_path__ + "static/img/SketchPnge0069fd6417050fddf217e7e36ce027b9ec4ca062864b4195d333a3e726c3a93.b99cd96c.png";